import styled from 'styled-components'

const Wrapper: any = styled.div`
  display: flex;
  max-height: 100vh;
  flex-direction: column;
`

export default Wrapper
